import axios from '@/plugins/axios.js'

export function getOrderItemPlanQRcode(params) {
    return axios.get('/qrcode', { params: params });
}